<template>
  <div style="width: 100%; height: 100%">
    <div class="main-content">
      <el-row :gutter="24" class="judge">
        <el-col :span="24" style="margin-bottom: 20px; padding-left: 0">
          <span class="judge-title">综合评价</span>
        </el-col>
        <el-col :span="24">
          <el-row :gutter="24" type="flex" justify="space-between">
            <el-col
              :span="7"
              class="primary-col"
              v-for="(item, index) in schoolStage"
              :key="item.value"
              :style="{ background: 'url(' + pic[index] + ') no-repeat right' }"
              @click.native="viewIndicator(updateTime[item.value])"
            >
              <div class="item">
                <p class="title">评价指标（{{ schoolStage[index].name }}）</p>
                <p class="view">内容、计分规则、模版查看</p>
                <p class="update">
                  <span style="display: inline-block; width: 120px">{{
                    updateTime[item.value] &&
                    updateTime[item.value].length > 0 &&
                    updateTime[item.value][0].updateTime | formatHour
                  }}</span>
                  更新
                </p>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="report" v-if="!$regional.HengshuiYanshou">
        <el-col :span="24" style="margin-bottom: 20px; padding-left: 0">
          <span class="judge-title">素质报告</span>
        </el-col>
        <el-col :span="24">
          <el-row :gutter="24" type="flex" justify="space-between">
            <el-col
              :span="7"
              class="primary-report"
              v-for="(item, index) in schoolStage"
              :key="item.value"
              :style="{
                background: 'url(' + reportPic[index] + ') no-repeat right',
              }"
            >
              <div class="item">
                <p class="title">报告模板（{{ item.name }}）</p>
                <p class="view" @click="viewHigherTemplate(item)">
                  模版查看{{index === 0 ? '、学科设置' : ''}}
                </p>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import SecondNavBar from '@/components/common/SecondNavBar'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar
  },

  data () {
    return {
      updateTime: {},
      schoolStage: [
        {
          name: '小学',
          value: 1
        },
        {
          name: '初中',
          value: 2
        },
        {
          name: '高中',
          value: 3
        }
      ],
      pic: [
        require('../../../assets/primary-standard.png'),
        require('../../../assets/junior-standard.png'),
        require('../../../assets/high-standard.png')
      ],
      reportPic: [
        require('../../../assets/primary-report.png'),
        require('../../../assets/junior-report.png'),
        require('../../../assets/high-report.png')
      ]
    }
  },

  watch: {

  },

  computed: {
  },

  mounted () {
    this.initData()
  },

  methods: {
    initData () {
      for (let index = 0; index < this.schoolStage.length; index++) {
        let element = this.schoolStage[index]
        this.$xhrGet(`/eval/indicators/list`, { schoolStage: element.value }).then(rs => {
          this.$set(this.updateTime, element.value, rs.data)
        })
      }
    },

    viewIndicator (item) {
      if (!item) {
        return false
      }
      sessionStorage.setItem('plans', JSON.stringify(item))
      if (item && item.length > 0 && item[0].schoolStage === 1) {
        this.$router.push({ name: 'AdminViewPrimaryTarget', params: { id: item[0].id } })
      } else {
        this.$router.push({ name: 'AdminViewHigherTarget', params: { id: item[0].id }, query: { stage: item[0].schoolStage } })
      }
    },

    viewHigherTemplate (item) {
      this.$router.push({ name: 'AdminViewTemplate', query: { stage: item.value } })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  float: right;
  height: calc(100% - 40px);
  width: calc(100% - 40px);
  padding: 20px;
  box-shadow: 0px 1px 4px 0px inset rgba(0, 0, 0, 0.12);
  background: var(--theme-background);
}
.judge {
  width: 100%;
  background: #fff;
  padding: 20px;
  margin: 0 !important;
  border-radius: 4px;
}
.judge-title {
  font-size: 16px;
  font-weight: 500;
  color: #444444;
}
.primary-col {
  padding: 0 !important;
  height: 140px;
  width: 360px;
  border-radius: 4px;
  cursor: pointer;
}
.primary-report {
  padding: 0 !important;
  height: 140px;
  width: 360px;
  border-radius: 4px;
}
.item {
  height: 90px;
  padding: 25px 0 25px 62px !important;
}
.title {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}
.view {
  margin-top: 15px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.update {
  margin-top: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
}
.report {
  width: 100%;
  background: #fff;
  padding: 20px;
  margin: 0 !important;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/apply/ApplyManage.vue